/**
 * 红娘充值档位请求接口
 * @author 王振宇
 * @since 2022-08-12
 */
export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request,
    serviceForMock = _ref.serviceForMock,
    requestForMock = _ref.requestForMock,
    mock = _ref.mock,
    faker = _ref.faker,
    tools = _ref.tools;
  return {
    GET_MATCHMAKERRECHARGEPOSITION_PAGE_LIST: function GET_MATCHMAKERRECHARGEPOSITION_PAGE_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/matchmakerRechargePosition/getPageList',
        method: 'get',
        params: data
      });
    },
    GET_MATCHMAKERRECHARGEPOSITION_LIST: function GET_MATCHMAKERRECHARGEPOSITION_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/matchmakerRechargePosition/getList',
        method: 'get',
        params: data
      });
    },
    GET_MATCHMAKERRECHARGEPOSITION_INFO: function GET_MATCHMAKERRECHARGEPOSITION_INFO() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/matchmakerRechargePosition/info',
        method: 'get',
        params: data
      });
    },
    SAVE_MATCHMAKERRECHARGEPOSITION: function SAVE_MATCHMAKERRECHARGEPOSITION() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/matchmakerRechargePosition/save',
        method: 'post',
        data: data
      });
    },
    UPDATE_MATCHMAKERRECHARGEPOSITION: function UPDATE_MATCHMAKERRECHARGEPOSITION() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/matchmakerRechargePosition/update',
        method: 'put',
        data: data
      });
    },
    DELETE_MATCHMAKERRECHARGEPOSITION: function DELETE_MATCHMAKERRECHARGEPOSITION() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/matchmakerRechargePosition/delete',
        method: 'delete',
        data: data
      });
    },
    DELETE_BATCH_MATCHMAKERRECHARGEPOSITION: function DELETE_BATCH_MATCHMAKERRECHARGEPOSITION() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/matchmakerRechargePosition/deleteBatch',
        method: 'delete',
        data: data
      });
    }
  };
});